module.exports = __webpack_public_path__ + "img/ssb_logo3.f063a3f5.png";